/* Swym Product Page button */

const swymObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList && node.classList.contains("swym-button-bar")) {
          const productGallery = document.querySelector(
            '.product product-gallery'
          );
          if (productGallery) {
            productGallery.appendChild(node);
            node.classList.add("loaded");
            swymObserver.disconnect();
          }
        }
      }
    });
  });
});

swymObserver.observe(document.body, {
  childList: true,
  subtree: true,
});


/* Swym Product Page button icon resize */
const svg = document.getElementById('swym-atw-pdp-button-icon');

if (svg && !svg.hasAttribute('viewBox')) {
  svg.setAttribute('viewBox', '0 0 24 24');
}

/* Swym Product Page button */

/* Global function for SearchSpring / Add to cart + drawer update */

// Utility to detect the dynamic Stretch section IDs for the cart
function getCartSectionIds() {
  const sections = [];
  document.querySelectorAll('[id^="shopify-section-"]').forEach(sec => {
    const id = sec.id.replace('shopify-section-', '');
    if (id.includes('cart-drawer') || id.includes('cart-icon-bubble')) {
      sections.push(id);
    }
  });
  return sections;
}

// Global function for Searchspring / custom triggers
window.addToCart = async function(variantId, quantity = 1) {
  try {
    const sections = getCartSectionIds();

    // Add item to cart
    const addResp = await fetch('/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    });

    const addData = await addResp.json();

    // Fetch full cart for item_count and totals
    const cart = await fetch('/cart.js').then(r => r.json());

    // Build cartContent like Stretch theme expects
    const cartContent = { sections: addData.sections, cart };

    // Prepare items array like theme
    const items = addData.hasOwnProperty("items") ? addData.items : [addData];

    // Dispatch variant:add event for internal theme listeners
    document.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: { items, cart: cartContent }
    }));

    // Dispatch cart:change event for drawer, badge, etc.
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: { baseEvent: "variant:add", cart: cartContent }
    }));

    // Safely open the cart drawer by triggering the toggle button
    const cartButton = document.querySelector('[data-action="toggle-cart"]');
    if (cartButton) cartButton.click();

  } catch (err) {
    console.error("addToCart error:", err);

    // Dispatch cart:error for theme listeners
    document.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: { error: err.message }
    }));

    // Trigger cart:refresh as fallback
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
};

/* End of Global function for SearchSpring / Add to cart + drawer update */

/* Back in stock notify me form */

class NotifyMeForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.button = this.querySelector('button[type="submit"]');
    this.errorElement = this.querySelector('.notify-form__error');
    this.successElement = this.querySelector('.notify-form__success');

    this.form?.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.isSubmitting) return;

    const email = this.input.value.trim();

    if (!email || !this.input.checkValidity()) {
      this.showError('Please enter a valid email address.');
      this.input.focus();
      return;
    }

    this.isSubmitting = true;
    this.hideError();
    this.button?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(this.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          shop: this.dataset.shop,
          productId: this.dataset.productId,
          variantId: this.dataset.variantId,
          productTitle: this.dataset.productTitle,
          productHandle: this.dataset.productHandle
        })
      });

      if (!response.ok) {
        throw new Error(`Subscription failed with status ${response.status}`);
      }

      this.form.hidden = true;
      this.successElement.hidden = false;
      this.closest('.notify-wrapper')?.classList.add('notify-wrapper--subscribed');
    } catch (error) {
      console.error('Notify me subscription error:', error);
      this.showError('Something went wrong. Please try again.');
    } finally {
      this.isSubmitting = false;
      this.button?.removeAttribute('aria-busy');
    }
  };

  showError(message) {
    if (!this.errorElement) return;

    this.errorElement.textContent = message;
    this.errorElement.hidden = false;
  }

  hideError() {
    if (!this.errorElement) return;

    this.errorElement.textContent = '';
    this.errorElement.hidden = true;
  }
}

customElements.define('notify-me-form', NotifyMeForm);

/* End of Back in stock notify me form */
